import { Box, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation,Trans} from 'react-i18next'

import { overviewItem } from './items'

const BookingsOverviewSection = () => {
  const theme = useTheme()
  const {t}=useTranslation()
  const itemsData = overviewItem()

  return (
    <Box mb={{ xs: '4rem', md: '7rem' }} sx={{ maxWidth: '100%', margin: '0 auto' }}>
      <Box pl={{ xs: 4, sm: 0 }} pr={{ xs: 4, sm: 0 }}>
        <Typography
          variant='h2'
          sx={{ color: 'publicPages.light' }}
          fontSize={{ xs: '1.5rem', md: '2.5rem' }}
          lineHeight={{ xs: '2.5rem', md: '3.375rem' }}
          fontWeight={600}
        >

          <Trans i18nKey={'featuresPage.bookingsOverview'} components={{ highlight: <span style={{color:theme.palette.primary.main}} />}} />
        </Typography>
        <Typography
          variant='h5'
          sx={{
            color: 'publicPages.main',
          }}
          lineHeight={'1.56rem'}
          fontWeight={400}
          mt={2}
          mb={'3.75rem'}
        >
          {t('featuresPage.stayOrganizedText')}
        </Typography>
      </Box>

      <Box sx={{ backgroundColor: 'publicPages.colorSeven' }} paddingY={'4.25rem'}>
        <Box sx={{ margin: '0 auto', maxWidth: '90rem' }}>
          <Grid
            container
            justifyContent={'center'}
            rowSpacing={{ xs: 4, md: 3 }}
            columnSpacing={{ sm: 2, md: 3, lg: 3 }}
          >
            {itemsData.map((item) => (
              <Grid xs={12} md={5} key={item.id} display='flex' justifyContent='center'>
                <Box
                  sx={{
                    width: '36.875rem',
                    height: '7.625rem',
                    borderRadius: '1rem',
                    border: 'solid 1px publicPages.colorEight',
                    backgroundColor: 'info.main',
                    padding: { xs: '1rem', md: '1rem', lg: '1.5rem' },
                    [theme.breakpoints.down(400)]: {
                      width: '25rem',
                      height: '12rem',
                    },
                    [theme.breakpoints.down(640)]: { margin: '1rem' },
                  }}
                  display='flex'
                  flexDirection={'row'}
                  alignItems={'center'}
                >
                  <Box component='img' src={item.icon} />

                  <Box
                    sx={{
                      textAlign: 'left',
                      marginLeft: { xs: '1.125rem', md: '0.5rem', lg: '1.125rem' },
                    }}
                  >
                    <Typography
                      variant='h4'
                      sx={{
                        fontSize: { xs: '1.25rem', md: '1rem', lg: '1.25rem' },
                        lineHeight: 1.25,
                        color: 'publicPages.colorDivider',
                      }}
                    >
                      {t(`featuresPage.${item.title}`)}
                    </Typography>
                    <Typography
                      variant='subtitle1'
                      sx={{
                        fontSize: { xs: '0.83rem', md: '0.84rem', lg: '0.875rem' },
                        fontWeight: 300,
                        color: 'publicPages.main',
                        lineHeight: { xs: '1.3rem', sm: '1.57rem' },
                        maxWidth: '27.75rem',
                        marginTop: '0.5rem',
                      }}
                    >
                      {t(`featuresPage.${item.description}`)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default BookingsOverviewSection
